export const DEFAULT_LOCALE = 'en';

export const normalizeLocale = locale => {
    if (Array.isArray(locale)) {
        return normalizeLocale(locale[0]);
    }

    return typeof locale === 'string' ? locale.trim() : '';
};

export const resolveRouteLocale = (query = {}) => {
    return normalizeLocale(query.lang) || normalizeLocale(query.locale);
};

export const resolvePreferredLocale = ({
    search = window.location.search,
    storage = localStorage,
    browser = navigator,
} = {}) => {
    const params = new URLSearchParams(search);
    const browserLocale =
        browser.languages?.find(language => normalizeLocale(language)) ||
        browser.language;

    return (
        normalizeLocale(params.get('lang')) ||
        normalizeLocale(params.get('locale')) ||
        normalizeLocale(storage.getItem('locale')) ||
        normalizeLocale(browserLocale) ||
        DEFAULT_LOCALE
    );
};
